module.exports = __webpack_public_path__ + "static/data-analytics-5e6221c936de746b51d021a54c8c5fe3.png";